export default __webpack_public_path__ + "static/media/light_mode_icon.fc0a3407.svg";